export default __webpack_public_path__ + "static/media/valleyPort9.eda97eb0.png";